<div class="ncis-badge">{{ data }}</div>
